import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';

export const PercentageUsedInPlan = () => {
  const formBag = useFormContext();

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.PercentageUsedInPlan"
      render={({ field }) => (
        <InputNumberMask
          {...field}
          rightIcon="far fa-percent"
          decimalScale={2}
          allowNegative={false}
          thousandSeparator={false}
          label="Percentage Used in Plan"
          tooltip="Please enter the percentage of the account value that is available to fund any goals or expenses."
        />
      )}
    />
  );
};
